import { each, selectAll } from '../../utils/dom';

export default {
  /**
   * Methods
   */
  methods: {
    togglePassword(e) {
      // toggle password between text and password types to show/hide password
      const input = e.target.nextElementSibling;
      if (input && input.type === 'password') {
        input.type = 'text';
        // add a toggled class so we know Vue's taking care of it
        input.classList.add('toggled');
      } else if (input && input.type === 'text') {
        input.type = 'password';
      }
    },

    hidePasswordText() {
      // switch all password fields back to password inputs
      const fields = selectAll('.form-field--password input');
      each(fields, field => {
        field.type = 'password';
      });
    },
  },
}



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/shared/vue/mixins/togglePassword.js